<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入盲盒名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.cate_id"
            placeholder="请选择盲盒分类"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加盲盒</el-button
          >

          <el-popover
            placement="bottom"
            title="显示列筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-s-tools" type="info"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="盲盒名称"
            prop="name"
            min-width="180"
            v-if="checkedColumns.includes('name')"
          />
          <el-table-column
            label="盲盒图片"
            width="120"
            align="center"
            v-if="checkedColumns.includes('image')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('price')"
          />
          <el-table-column
            label="分类名称"
            prop="cate_name"
            width="120"
            align="center"
            v-if="checkedColumns.includes('cate_name')"
          />
          <el-table-column
            label="销量"
            prop="sales"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sales')"
          />
          <el-table-column
            label="周期库存"
            prop="cycle_num"
            width="120"
            align="center"
            v-if="checkedColumns.includes('cycle_num')"
          />
          <el-table-column
            label="收入"
            prop="income"
            width="100"
            align="center"
            v-if="checkedColumns.includes('income')"
          />
          <el-table-column
            label="支出"
            prop="pay"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pay')"
          />
          <el-table-column
            label="利润"
            width="120"
            align="center"
            v-if="checkedColumns.includes('profit')"
          >
            <template slot-scope="scope">
              <span v-if="Number(scope.row.income) === 0">--</span>
              <span
                v-else
                :style="{
                  color:
                    scope.row.income - scope.row.pay >= 0
                      ? '#00c48c'
                      : '#f56c6c',
                }"
              >
                {{
                  (
                    ((scope.row.income - scope.row.pay) / scope.row.income) *
                    100
                  ).toFixed(2)
                }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="排序"
            prop="sort"
            width="80"
            align="center"
            v-if="checkedColumns.includes('sort')"
          />

          <el-table-column
            label="定制人ID"
            prop="custom_user_id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('custom_user_id')"
          />

          <el-table-column
            label="剩余时间"
            width="180"
            align="center"
            v-if="checkedColumns.includes('remainText')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.remainText }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="定制开始"
            prop="custom_start"
            width="180"
            align="center"
            v-if="checkedColumns.includes('custom_start')"
          />
          <el-table-column
            label="定制结束"
            prop="custom_end"
            width="180"
            align="center"
            v-if="checkedColumns.includes('custom_end')"
          />

          <el-table-column
            label="状态"
            width="180"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            v-if="checkedColumns.includes('updated_at')"
          />

          <el-table-column
            label="操作"
            width="320"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openPrizeDialog(scope.row)"
                >赏品</el-button
              >
              <el-button
                type="text"
                icon="el-icon-copy-document"
                style="color: #67c23a"
                @click.stop="handleCopyBox(scope.row.id)"
                >复制</el-button
              >
              <el-button
                v-if="scope.row.cate_id == 2"
                type="text"
                icon="el-icon-tickets"
                style="color: #e6a23c"
                @click.stop="openManyPrizeDialog(scope.row)"
                >N次赏</el-button
              >
              <el-button
  type="text"
  icon="el-icon-document"
  style="color:#409EFF"
  @click.stop="openDrawRecord(scope.row)"
>抽奖记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 赏品弹窗 -->
        <el-dialog
          title="盲盒赏品列表"
          :visible.sync="prizeDialogVisible"
          width="1400px"
          append-to-body
          @close="resetPrizeSearch"
        >
          <div
            style="
              margin-bottom: 15px;
              display: flex;
              gap: 10px;
              align-items: center;
            "
          >
            <el-select
              v-model="prizeSearch.type"
              placeholder="盲盒类型"
              clearable
              style="width: 180px"
              @change="handlePrizeTypeChange"
            >
              <el-option
                v-for="item in prizeTypeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>

            <el-select
              v-model="prizeSearch.level_id"
              placeholder="商品等级"
              clearable
              style="width: 180px"
            >
              <el-option
                v-for="item in prizeLevelOptions"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>

            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getBoxPrizeList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetPrizeSearch"
              >重置</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openAddPrizeDialog"
              >添加赏品</el-button
            >
          </div>

          <div style="margin-bottom: 25px">
            <p style="font-weight: bold; margin-bottom: 8px">
              待提交赏品（可编辑概率）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="tempPrizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <!-- 新增赏品ID -->
                <el-table-column label="赏品ID" width="100" align="center">
                  <template #default="scope">
                    {{ scope.row.goods_id || "-" }}
                  </template>
                </el-table-column>

                <el-table-column label="商品图片" width="100" align="center">
                  <template #default="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />

                <el-table-column label="商品类型" width="130" align="center">
                  <template #default="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column label="等级" width="140" align="center">
                  <template #default="scope">
                    <el-select
                      v-model="scope.row.level_id"
                      size="mini"
                      placeholder="选择等级"
                      style="width: 120px"
                      @change="handlePrizeLevelChange(scope.row)"
                    >
                      <el-option
                        v-for="item in levelList"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>

                <!-- 概率 支持小数 保留两位 -->
                <el-table-column label="概率(%)" width="130" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.probability"
                      size="mini"
                      style="width: 100px"
                      placeholder="概率"
                      @input="
                        scope.row.probability = scope.row.probability.replace(
                          /[^\d.]/g,
                          ''
                        )
                      "
                      @blur="formatTwoDecimal(scope.row, 'probability')"
                    />
                  </template>
                </el-table-column>

                <!-- 价格 -->
                <el-table-column label="价格" width="130" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.price"
                      size="mini"
                      style="width: 100px"
                      placeholder="价格"
                      @input="
                        scope.row.price = scope.row.price.replace(/[^\d.]/g, '')
                      "
                      @blur="formatTwoDecimal(scope.row, 'price')"
                    />
                  </template>
                </el-table-column>

                <!-- 兑换价格 -->
                <el-table-column label="兑换价格" width="140" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.recovery_price"
                      size="mini"
                      style="width: 100px"
                      placeholder="兑换价格"
                      @input="
                        scope.row.recovery_price =
                          scope.row.recovery_price.replace(/[^\d.]/g, '')
                      "
                      @blur="formatTwoDecimal(scope.row, 'recovery_price')"
                    />
                  </template>
                </el-table-column>

                <!-- 原始数量 -->
                <el-table-column label="原始数量" width="140" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.origin_num"
                      size="mini"
                      style="width: 100px"
                      placeholder="原始数量"
                      @input="
                        scope.row.origin_num = scope.row.origin_num.replace(
                          /[^\d.]/g,
                          ''
                        )
                      "
                      @blur="formatTwoDecimal(scope.row, 'origin_num')"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="100" align="center">
                  <template #default="scope">
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="delTempPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div>
            <p style="font-weight: bold; margin-bottom: 8px">
              已有赏品列表（数据库）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="prizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="商品ID"
                  width="100"
                  align="center"
                  prop="goods_id"
                />
                <el-table-column
                  label="赏品ID"
                  width="100"
                  align="center"
                  prop="id"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />

                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="120"
                  align="center"
                />

                <el-table-column label="概率(%)" width="130" align="center">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.probability).toFixed(4) }}%
                  </template>
                </el-table-column>

                <el-table-column label="原始概率" width="130" align="center">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.origin_probability).toFixed(4) }}%
                  </template>
                </el-table-column>

                <el-table-column label="真实概率" width="130" align="center">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.real_probability).toFixed(4) }}%
                  </template>
                </el-table-column>

                <el-table-column label="价格" width="130" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.price }}
                  </template>
                </el-table-column>

                <el-table-column label="兑换价格" width="140" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.recovery_price }}
                  </template>
                </el-table-column>
                <el-table-column label="商品类型" width="140" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="原始数量" width="140" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.origin_num }}
                  </template>
                </el-table-column>

                <el-table-column label="剩余数量" width="140" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.num }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="180"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click.stop="openEditPrizeDialog(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="handleDelBoxPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>

              <!-- ====================== 概率总和统计 ====================== -->
              <div
                style="
                  margin-top: 12px;
                  display: flex;
                  gap: 20px;
                  padding: 8px 12px;
                  background: #f7f8fa;
                  border-radius: 6px;
                "
              >
                <div>
                  <span style="color: #333; font-weight: 500">概率总和：</span>
                  <span
                    style="color: #1989fa; font-size: 14px; font-weight: bold"
                  >
                    {{ sum_numsum_proObj.sum_pro }}%
                  </span>
                </div>
                <div>
                  <span style="color: #333; font-weight: 500"
                    >原始数量总和：</span
                  >
                  <span
                    style="color: #00c48c; font-size: 14px; font-weight: bold"
                  >
                    {{ sum_numsum_proObj.sum_num }}
                  </span>
                </div>
              </div>

              <el-pagination
                @size-change="handlePrizeSizeChange"
                @current-change="handlePrizeCurrentChange"
                :current-page="prizeSearch.page"
                :page-size="prizeSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="prizeTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="prizeDialogVisible = false">关闭</el-button>
            <el-button
              type="primary"
              @click="submitAllPrize"
              :loading="submitLoading"
              >确认提交选中赏品</el-button
            >
          </div>

          <el-dialog
            title="选择商品（添加到当前盲盒）"
            :visible.sync="addPrizeDialogVisible"
            width="1100px"
            append-to-body
            @close="resetGoodsSearch"
          >
            <div
              style="
                margin-bottom: 15px;
                display: flex;
                gap: 10px;
                align-items: center;
              "
            >
              <el-input
                v-model="goodsSearch.title"
                placeholder="商品名称"
                clearable
                style="width: 220px"
              ></el-input>

              <el-select
                v-model="goodsSearch.type"
                placeholder="盲盒类型"
                clearable
                style="width: 180px"
                @change="handleGoodsTypeChange"
              >
                <el-option
                  v-for="item in goodsTypeOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>

              <el-select
                v-model.number="goodsSearch.level_id"
                placeholder="商品等级"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in goodsLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
            </div>

            <div v-loading="goodsLoading" element-loading-text="加载商品中...">
              <el-table
                :data="goodsList"
                border
                stripe
                size="small"
                style="width: 100%"
                @row-click="handleSelectGoods"
                highlight-current-row
              >
                <el-table-column label="选择" width="60" align="center">
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row._checked"
                      @change="handleSelectGoods(scope.row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="ID" prop="id" min-width="100" />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="title"
                  min-width="220"
                />
                <el-table-column label="商品类型" width="130" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="业务类型"
                  prop="type_name"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="售价"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                />
              </el-table>

              <el-pagination
                @size-change="handleGoodsSizeChange"
                @current-change="handleGoodsCurrentChange"
                :current-page="goodsSearch.page"
                :page-size="goodsSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="goodsTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>

            <div slot="footer">
              <el-button @click="addPrizeDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="addSelectedToPrizeList"
                >确认添加选中商品</el-button
              >
            </div>
          </el-dialog>

          <el-dialog
            title="编辑赏品"
            :visible.sync="editPrizeDialogVisible"
            width="700px"
            append-to-body
          >
            <el-form
              :model="editPrizeForm"
              label-width="110px"
              ref="editPrizeRef"
              style="margin-top: 20px"
            >
              <el-form-item label="商品信息">
                <div style="display: flex; align-items: center; gap: 12px">
                  <img
                    :src="editPrizeForm.goods_image"
                    style="
                      width: 60px;
                      height: 60px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                  <span style="font-size: 14px; font-weight: 500">{{
                    editPrizeForm.goods_title
                  }}</span>
                </div>
              </el-form-item>
              <el-form-item label="商品ID">
                <el-input v-model="editPrizeForm.goods_id" disabled />
              </el-form-item>
              <el-form-item label="赏品ID">
                <el-input v-model="editPrizeForm.prize_id" disabled />
              </el-form-item>
              <el-form-item label="原始数量" prop="origin_num">
                <el-input
                  v-model.number="editPrizeForm.origin_num"
                  type="number"
                  placeholder="请输入原始数量"
                />
              </el-form-item>
              <el-form-item label="商品类型">
                <span :style="{ color: '#666', fontSize: '14px' }">
                  {{
                    editPrizeForm.goods_type == 1
                      ? "真实赏品"
                      : editPrizeForm.goods_type == 2
                      ? "虚拟赏品(钻石)"
                      : "未知"
                  }}
                </span>
              </el-form-item>
              <el-form-item label="展示概率" prop="probability">
                <el-input
                  v-model.number="editPrizeForm.probability"
                  type="number"
                  placeholder="请输入展示概率"
                />
              </el-form-item>

              <el-form-item label="等级" prop="level_id">
                <el-select
                  v-model="editPrizeForm.level_id"
                  placeholder="选择等级"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.level_id"
                    :label="item.name"
                    :value="item.level_id + ''"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="价格" prop="price">
                <el-input
                  v-model.number="editPrizeForm.price"
                  type="number"
                  placeholder="请输入价格"
                />
              </el-form-item>

              <el-form-item label="兑换价格" prop="recovery_price">
                <el-input
                  v-model.number="editPrizeForm.recovery_price"
                  type="number"
                  placeholder="请输入兑换价格"
                />
              </el-form-item>
            </el-form>

            <div slot="footer" style="text-align: right">
              <el-button @click="editPrizeDialogVisible = false"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="submitEditPrize"
                :loading="editPrizeLoading"
                >确认保存</el-button
              >
            </div>
          </el-dialog>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加盲盒' : '编辑盲盒'"
          :visible.sync="pcDialogVisible"
          width="750px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="120px"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="pcForm.name"
                placeholder="请输入盲盒名称"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="分类ID" prop="cate_id">
              <el-select
                v-model.number="pcForm.cate_id"
                placeholder="请选择分类"
                style="width: 320px"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="盲盒图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="pcForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="pcForm.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="价格" prop="price">
              <el-input
                v-model="pcForm.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="pcForm.sort"
                placeholder="请输入排序值"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="周期数量" prop="cycle_num">
              <el-input
                v-model="pcForm.cycle_num"
                placeholder="请输入周期库存"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="流水金额（流水赏）">
              <el-input
                v-model="pcForm.flow_amount"
                placeholder="选填，流水赏专用流水金额"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="卡册门票（卡册）">
              <el-input
                v-model="pcForm.goods_id"
                placeholder="选填，卡册专用门票ID"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="定制人ID">
              <el-input
                v-model="pcForm.custom_user_id"
                placeholder="可选"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="定制开始时间">
              <el-date-picker
                v-model="pcForm.custom_start"
                type="datetime"
                placeholder="选择定制开始时间"
                style="width: 320px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="定制结束时间">
              <el-date-picker
                v-model="pcForm.custom_end"
                type="datetime"
                placeholder="选择定制结束时间"
                style="width: 320px"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="endPickerOptions"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="等级概率" prop="blind_probability">
              <el-table
                :data="pcProbList"
                border
                size="mini"
                style="width: 400px"
              >
                <el-table-column
                  label="等级ID"
                  prop="level_id"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="等级名称"
                  prop="level_name"
                  min-width="100"
                />
                <el-table-column label="概率(%)" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.probability"
                      type="text"
                      size="mini"
                      style="width: 100px"
                      @change="pcHandleProbChange"
                      oninput="value=value.replace(/[^\d\.]/g,''); if(value.split('.').length>2)value=value.replace(/\.+$/,'')"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="pcImageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="pcGetImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="pcResetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in pcImageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <el-pagination
              @size-change="pcHandleImageSizeChange"
              @current-change="pcHandleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pcImageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 详情弹窗 -->
        <el-dialog
          :title="detailRow ? `${detailRow.name} 的盲盒详情` : '盲盒详情'"
          :visible.sync="detailDialogVisible"
          width="850px"
          append-to-body
          :close-on-click-modal="false"
        >
          <div
            class="detail-content"
            v-loading="detailLoading"
            element-loading-text="加载详情中..."
          >
            <div v-if="detailRow" style="padding: 10px 0">
              <div
                style="display: flex; align-items: center; margin-bottom: 20px"
              >
                <img
                  :src="detailRow.image"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 6px;
                  "
                />
                <div style="margin-left: 16px">
                  <h2 style="margin: 0; font-size: 18px">
                    {{ detailRow.name }}
                  </h2>
                  <p style="margin: 5px 0 0; color: #666">
                    盲盒ID：{{ detailRow.id }}
                  </p>
                </div>
              </div>

              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="盲盒名称">{{
                  detailRow.name
                }}</el-descriptions-item>
                <el-descriptions-item label="分类">{{
                  detailRow.cate_name
                }}</el-descriptions-item>
                <el-descriptions-item label="价格">{{
                  detailRow.price
                }}</el-descriptions-item>
                <el-descriptions-item label="销量">{{
                  detailRow.sales
                }}</el-descriptions-item>
                <el-descriptions-item label="周期库存">{{
                  detailRow.cycle_num
                }}</el-descriptions-item>
                <el-descriptions-item label="收入">{{
                  detailRow.income
                }}</el-descriptions-item>
                <el-descriptions-item label="支出">{{
                  detailRow.pay
                }}</el-descriptions-item>
                <el-descriptions-item label="利润">
                  <span v-if="Number(detailRow.income) === 0">--</span>
                  <span
                    v-else
                    :style="{
                      color:
                        detailRow.income - detailRow.pay >= 0
                          ? '#00c48c'
                          : '#f56c6c',
                    }"
                  >
                    {{
                      (
                        ((detailRow.income - detailRow.pay) /
                          detailRow.income) *
                        100
                      ).toFixed(2)
                    }}%
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="排序">{{
                  detailRow.sort
                }}</el-descriptions-item>
                <el-descriptions-item label="定制人ID">{{
                  detailRow.custom_user_id || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="剩余时间">{{
                  detailRow.remainText
                }}</el-descriptions-item>
                <el-descriptions-item label="定制开始">{{
                  detailRow.custom_start || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="定制结束">{{
                  detailRow.custom_end || "无"
                }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                  <span
                    :style="{
                      color: detailRow.status == 1 ? '#00C48C' : '#F56C6C',
                    }"
                  >
                    {{ detailRow.status == 1 ? "上架" : "下架" }}
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                  detailRow.created_at
                }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{
                  detailRow.updated_at
                }}</el-descriptions-item>
              </el-descriptions>

              <div
                style="margin-top: 20px"
                v-if="
                  detailRow.blind_probability &&
                  detailRow.blind_probability.length
                "
              >
                <p style="font-weight: bold; margin-bottom: 10px">
                  等级概率配置
                </p>
                <el-table
                  :data="detailRow.blind_probability"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    label="等级ID"
                    prop="level_id"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    label="等级名称"
                    prop="level_name"
                    min-width="120"
                  />
                  <el-table-column
                    label="概率(%)"
                    prop="probability"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ parseFloat(scope.row.probability).toFixed(4) }}%
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else style="margin-top: 20px; color: #999">
                暂无等级概率配置
              </div>
            </div>
          </div>

          <div slot="footer">
            <el-button @click="detailDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- ====================== 加一次N次赏 弹窗 ====================== -->
    <el-dialog
      title="添加N次赏"
      :visible.sync="manyPrizeDialogVisible"
      width="1200px"
      append-to-body
    >
      <div style="margin-bottom: 15px">
        <el-button type="success" icon="el-icon-plus" @click="openAddManyPrize">
          添加N次赏
        </el-button>
      </div>

      <div v-loading="manyLoading">
        <el-table :data="manyPrizeList" border stripe size="small">
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="商品ID"
            prop="goods_id"
            width="100"
            align="center"
          />
          <el-table-column label="商品图片" width="100" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.goods_image"
                style="width: 50px; height: 50px; object-fit: cover"
                v-if="scope.row.goods_image"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="goods_name" min-width="160" />
          <el-table-column label="类型" width="110" align="center">
            <template slot-scope="scope">
              {{
                scope.row.goods_type == 1
                  ? "真实赏品"
                  : scope.row.goods_type == 2
                  ? "虚拟赏品"
                  : "未知"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="等级ID"
            prop="level_id"
            width="80"
            align="center"
          />
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
          />
          <el-table-column
            label="兑换价"
            prop="recovery_price"
            width="110"
            align="center"
          />
          <el-table-column label="概率(%)" width="110" align="center">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.probability).toFixed(4) }}%
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="170"
            align="center"
          />
          <el-table-column
            label="操作"
            width="160"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="openEditManyPrize(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="handleDelManyPrize(scope.row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleManySizeChange"
          @current-change="handleManyCurrentChange"
          :current-page="manySearch.page"
          :page-size="manySearch.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="manyTotal"
          style="margin-top: 20px; text-align: right"
        />
      </div>
    </el-dialog>

    <!-- 添加N次赏 → 选择赏品库 -->
    <el-dialog
      title="选择赏品（添加到N次赏）"
      :visible.sync="manyAddDialogVisible"
      width="1100px"
      append-to-body
    >
      <div
        style="
          margin-bottom: 15px;
          display: flex;
          gap: 10px;
          align-items: center;
        "
      >
        <el-input
          v-model="manyGoodsSearch.title"
          placeholder="商品名称"
          clearable
          style="width: 220px"
        ></el-input>

        <el-select
          v-model="manyGoodsSearch.type"
          placeholder="商品类型"
          clearable
          style="width: 180px"
          @change="handleManyGoodsTypeChange"
        >
          <el-option
            v-for="item in manyGoodsTypeOptions"
            :key="item.type"
            :label="item.desc"
            :value="item.type"
          />
        </el-select>

        <el-select
          v-model="manyGoodsSearch.level_id"
          placeholder="等级"
          clearable
          style="width: 180px"
        >
          <el-option
            v-for="item in manyGoodsLevelOptions"
            :key="item.level_id"
            :label="item.name"
            :value="item.level_id"
          />
        </el-select>

        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getManyGoodsList"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resetManyGoodsSearch"
          >重置</el-button
        >
      </div>

      <div v-loading="manyGoodsLoading">
        <el-table
          :data="manyGoodsList"
          border
          stripe
          size="small"
          style="width: 100%"
          @row-click="selectManyGoods"
          highlight-current-row
        >
          <el-table-column label="选择" width="80" align="center">
            <template slot-scope="scope">
              <el-radio
                v-model="manyForm.goods_id"
                :label="scope.row.id + ''"
                @change="selectManyGoods(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="图片" width="100" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 50px; height: 50px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="title" min-width="180" />
          <el-table-column label="类型" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.goods_type == 1 ? "真实" : "虚拟" }}
            </template>
          </el-table-column>
          <el-table-column
            label="等级"
            prop="level_name"
            width="100"
            align="center"
          />
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
          />
        </el-table>

        <el-pagination
          @size-change="handleManyGoodsSizeChange"
          @current-change="handleManyGoodsCurrentChange"
          :current-page="manyGoodsSearch.page"
          :page-size="manyGoodsSearch.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="manyGoodsTotal"
          style="margin-top: 15px; text-align: right"
        />
      </div>

      <!-- 已选商品信息 -->
      <div
        style="
          margin-top: 15px;
          padding: 10px;
          border: 1px solid #eee;
          border-radius: 6px;
        "
      >
        <p style="margin: 0 0 8px; font-weight: bold">已选择赏品</p>
        <div
          v-if="manyForm.goods_image"
          style="display: flex; align-items: center; gap: 10px"
        >
          <img
            :src="manyForm.goods_image"
            style="width: 60px; height: 60px; object-fit: cover"
          />
          <div>
            <div>ID：{{ manyForm.goods_id }}</div>
            <div>类型：{{ manyForm.goods_type == 1 ? "真实" : "虚拟" }}</div>
          </div>
        </div>
        <div v-else>请在上方选择赏品</div>
      </div>

      <!-- 价格概率输入 -->
      <el-form label-width="100px" style="margin-top: 15px" size="small">
        <el-form-item label="价格">
          <el-input v-model.number="manyForm.price" placeholder="价格" />
        </el-form-item>
        <el-form-item label="兑换价格">
          <el-input
            v-model.number="manyForm.recovery_price"
            placeholder="兑换价格"
          />
        </el-form-item>
        <el-form-item label="概率(%)">
          <el-input
            v-model="manyForm.probability"
            type="text"
            size="mini"
            style="width: 100px"
            @change="pcHandleProbChange"
            oninput="value=value.replace(/[^\d\.]/g,''); if(value.split('.').length>2)value=value.replace(/\.+$/,'')"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="manyAddDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitAddManyPrize"
          :loading="manyLoading"
          >确认添加</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑N次赏 -->
    <el-dialog
      title="编辑N次赏"
      :visible.sync="manyEditDialogVisible"
      width="600px"
      append-to-body
    >
      <el-form label-width="100px" size="small">
        <el-form-item label="商品ID">
          <el-input v-model="manyForm.goods_id" disabled />
        </el-form-item>
        <el-form-item label="商品图片">
          <img
            :src="manyForm.goods_image"
            style="width: 70px; height: 70px; object-fit: cover"
          />
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model.number="manyForm.price" />
        </el-form-item>
        <el-form-item label="兑换价格">
          <el-input v-model.number="manyForm.recovery_price" />
        </el-form-item>
        <el-form-item label="概率(%)">
          <el-input v-model="manyForm.probability" />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="manyEditDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitEditManyPrize"
          :loading="manyLoading"
          >确认保存</el-button
        >
      </div>
    </el-dialog>
    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="盲盒名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.cate_id"
              placeholder="盲盒分类"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in cateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | {{ item.cate_name }} | 售价¥{{
                    item.price
                  }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>库存：{{ item.cycle_num }}</div>
              <div>剩余：{{ item.remainText }}</div>
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item.id)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="盲盒详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="盲盒ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="盲盒名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>

              <el-descriptions-item label="分类">{{
                mobileDetailRow.cate_name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="利润">
                <span v-if="mobileDetailRow.income == 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) /
                        mobileDetailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="周期库存">{{
                mobileDetailRow.cycle_num
              }}</el-descriptions-item>
              <el-descriptions-item label="剩余时间">{{
                mobileDetailRow.remainText
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端编辑弹窗 -->
        <el-dialog
          title="编辑盲盒"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="盲盒分类" prop="cate_id">
              <el-select
                v-model.number="mobileEditForm.cate_id"
                placeholder="分类"
                size="medium"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="盲盒图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileEditForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileEditForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="周期库存" prop="cycle_num">
              <el-input
                v-model="mobileEditForm.cycle_num"
                placeholder="库存"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="流水金额">
              <el-input
                v-model="mobileEditForm.flow_amount"
                placeholder="选填"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="卡册门票">
              <el-input
                v-model="mobileEditForm.goods_id"
                placeholder="选填"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="排序"
                size="medium"
              />
            </el-form-item>

            <el-form-item label="定制人ID">
              <el-input
                v-model="mobileEditForm.custom_user_id"
                placeholder="可选"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="定制开始">
              <el-date-picker
                v-model="mobileEditForm.custom_start"
                type="datetime"
                placeholder="开始时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="定制结束">
              <el-date-picker
                v-model="mobileEditForm.custom_end"
                type="datetime"
                placeholder="结束时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="等级概率">
              <el-table
                :data="mobileProbList"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="等级"
                  prop="level_name"
                  min-width="100"
                />
                <el-table-column label="概率(%)" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.probability"
                      type="text"
                      size="mini"
                      style="width: 100px"
                      @change="pcHandleProbChange"
                      oninput="value=value.replace(/[^\d\.]/g,''); if(value.split('.').length>2)value=value.replace(/\.+$/,'')"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端独立图片弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="mobileImageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="mobileGetImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="mobileResetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in mobileImageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="mobileHandleImageSizeChange"
                @current-change="mobileHandleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="mobileImageTotal"
            pager-count="2"
            small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

        <!-- ====================== 新增：盲盒抽奖记录弹窗 ====================== -->
    <el-dialog
      title="盲盒抽奖记录"
      :visible.sync="drawRecordDialogVisible"
      width="1400px"
      append-to-body
    >
      <div v-loading="drawRecordLoading" element-loading-text="加载抽奖记录...">
        <el-table
          :data="drawRecordList"
          border
          stripe
          size="small"
          style="width:100%"
        >
          <el-table-column label="记录ID" prop="id" width="80" align="center" />
          <el-table-column label="用户ID" prop="user_id" width="90" align="center" />
          <el-table-column label="用户头像" width="100" align="center">
            <template #default="scope">
              <img
                :src="scope.row.avatar"
                style="width:50px;height:50px;object-fit:cover;border-radius:50%"
              />
            </template>
          </el-table-column>
          <el-table-column label="用户昵称" prop="nickname" min-width="120" />
          <el-table-column label="赏品图片" width="100" align="center">
            <template #default="scope">
              <img
                :src="scope.row.box_prize_image"
                style="width:50px;height:50px;object-fit:cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="赏品名称" prop="box_prize_name" min-width="130" />
          <el-table-column label="等级" prop="level_name" width="90" align="center" />
          <el-table-column label="单价" prop="price" width="90" align="center" />
          <el-table-column label="兑换价" prop="recovery_price" width="100" align="center" />
          <el-table-column label="数量" prop="num" width="80" align="center" />
          <el-table-column label="倍数" prop="multiple" width="80" align="center" />
          <el-table-column label="订单ID" prop="box_order_id" width="110" align="center" />
          <el-table-column label="创建时间" prop="created_at" width="170" align="center" />
        </el-table>

        <el-pagination
          @size-change="handleDrawRecordSizeChange"
          @current-change="handleDrawRecordCurrentChange"
          :current-page="drawRecordSearch.page"
          :page-size="drawRecordSearch.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="drawRecordTotal"
          style="margin-top:15px;text-align:right"
        />
      </div>
      <div slot="footer">
        <el-button @click="drawRecordDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BlindBoxTable",
  data() {
    return {
      // 移动端独立
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        price: "",
        cycle_num: "",
        sort: "",
        custom_user_id: "",
        custom_start: "",
        custom_end: "",
        blind_probability: "[]",
        flow_amount: "", // 新增
        goods_id: "", // 新增
      },
      mobileProbList: [],
      sum_numsum_proObj: {},
      // 加一次N次赏（批量赏）
      manyPrizeDialogVisible: false,
      manyPrizeList: [],
      manyLoading: false,
      currentManyBoxId: null,
      manyAddDialogVisible: false,
      manyEditDialogVisible: false,
      manyForm: {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        probability: "",
      },
      // 赏品库选择
      manyGoodsList: [],
      manyGoodsLoading: false,
      manyGoodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 1,
      },
      manyGoodsTotal: 0,
      manyGoodsTypeOptions: [],
      manyGoodsLevelOptions: [],
      // N次赏分页
      manySearch: { page: 1, page_size: 10 },
      manyTotal: 0,
      // PC 独立弹窗
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        sort: "",
        cycle_num: "",
        price: "",
        custom_user_id: "",
        custom_start: "",
        custom_end: "",
        blind_probability: "[]",
        flow_amount: "", // 新增
        goods_id: "", // 新增
      },
      pcProbList: [],

      // PC 图片独立
      pcImageDialogVisible: false,
      pcImageLoading: false,
      pcImageList: [],
      pcImageTotal: 0,
      pcImageSearch: { page: 1, page_size: 10, type: "" },
      pcSelectedImageUrl: "",

      // 移动端图片独立
      mobileImageDialogVisible: false,
      mobileImageLoading: false,
      mobileImageList: [],
      mobileImageTotal: 0,
      mobileImageSearch: { page: 1, page_size: 10, type: "" },
      mobileSelectedImageUrl: "",

      loading: false,
      submitLoading: false,
      tableData: [],
      pageTotal: 0,
      cateList: [],
      levelList: [],
      searchParams: { page: 1, page_size: 10, name: "", cate_id: "" },
      addRules: {
        name: [{ required: true, message: "请输入盲盒名称", trigger: "blur" }],
        cate_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        cycle_num: [
          { required: true, message: "请输入周期数量", trigger: "blur" },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.pcForm.custom_start) {
            return time.getTime() < Date.now() - 24 * 3600 * 1000;
          }
          return time.getTime() < new Date(this.pcForm.custom_start).getTime();
        },
      },
      image_type: [],
      timer: null,
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "盲盒名称", prop: "name" },
        { label: "盲盒图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "分类名称", prop: "cate_name" },
        { label: "销量", prop: "sales" },
        { label: "周期库存", prop: "cycle_num" },
        { label: "收入", prop: "income" },
        { label: "支出", prop: "pay" },
        { label: "利润", prop: "profit" },
        { label: "排序", prop: "sort" },
        { label: "定制人ID", prop: "custom_user_id" },
        { label: "剩余时间", prop: "remainText" },
        { label: "定制开始", prop: "custom_start" },
        { label: "定制结束", prop: "custom_end" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "cate_name",
        "sales",
        "cycle_num",
        "income",
        "pay",
        "profit",
        "sort",
        "custom_user_id",
        "remainText",
        "custom_start",
        "custom_end",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],
      detailDialogVisible: false,
      detailRow: null,
      detailLoading: false,

      // 赏品
      prizeDialogVisible: false,
      prizeLoading: false,
      prizeList: [],
      tempPrizeList: [],
      prizeTotal: 0,
      currentBoxId: null,
      prizeSearch: { page: 1, page_size: 10, type: "", level_id: "" },
      goodsTypeSelectOptions: [],
      prizeTypeOptions: [],
      prizeLevelOptions: [],
      addPrizeDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsTypeOptions: [],
      goodsLevelOptions: [],
      goodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 1,
      },
      editPrizeDialogVisible: false,
      editPrizeLoading: false,
      editPrizeForm: {
        prize_id: "",
        origin_num: "",
        probability: "",
        goods_id: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
      },
      selectedGoodsIds: [],
      addedGoodsIds: [],
      // 新增：抽奖记录弹窗
drawRecordDialogVisible: false,
drawRecordLoading: false,
drawRecordList: [],
drawRecordTotal: 0,
currentDrawBoxId: null,
drawRecordSearch: {
  page: 1,
  page_size: 10,
  type: 1,
  box_id: "",
  box: ""
},
    };
  },
  created() {
    this.getList();
    this.loadGoodsTypeOptions();
  },
  mounted() {
    this.startRealTimeRefresh();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  // computed: {
  //   // 展示概率总和
  //   totalProbability() {
  //     return this.prizeList.reduce((sum, item) => {
  //       return sum + (parseFloat(item.probability) || 0);
  //     }, 0);
  //   },
  //   // 真实概率总和
  //   totalorigin_num() {
  //     return this.prizeList.reduce((sum, item) => {
  //       return sum + (parseFloat(item.origin_num) || 0);
  //     }, 0);
  //   },
  // },
  methods: {
    // ====================== 复制盲盒 ======================
    async handleCopyBox(box_id) {
      this.$confirm("确定复制该盲盒？将生成全新盲盒数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          this.loading = true;
          try {
            const res = await api.blindBox.copyBox({ box_id });
            if (res.data.code == 1000) {
              this.$message.success("复制成功");
              this.getList();
            }
          } catch (e) {
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },

    // ====================== 加一次N次赏 ======================
    openManyPrizeDialog(row) {
      this.currentManyBoxId = row.id;
      this.manyPrizeDialogVisible = true;
      this.getManyPrizeList();
    },
    async getManyPrizeList() {
      this.manyLoading = true;
      try {
        const res = await api.blindBox.blindManyPrizeList({
          params: {
            box_id: this.currentManyBoxId,
            page: this.manySearch.page,
            page_size: this.manySearch.page_size,
          },
        });
        if (res.data.code == 1000) {
          this.manyPrizeList = res.data.data.data || [];
          this.manyTotal = res.data.data.total || 0;
        }
      } catch (e) {
      } finally {
        this.manyLoading = false;
      }
    },
    handleManySizeChange(val) {
      this.manySearch.page_size = val;
      this.getManyPrizeList();
    },
    handleManyCurrentChange(val) {
      this.manySearch.page = val;
      this.getManyPrizeList();
    },

    // 打开添加N次赏
    openAddManyPrize() {
      this.manyForm = {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        probability: "",
      };
      this.manyAddDialogVisible = true;
      this.resetManyGoodsSearch();
      this.getManyGoodsList();
    },

    // 赏品库 - 获取商品列表
    getManyGoodsList() {
      this.manyGoodsLoading = true;
      api.goods
        .index({ params: this.manyGoodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.manyGoodsList = res.data.data.data || [];
            this.manyGoodsTotal = res.data.data.total || 0;
            this.manyGoodsTypeOptions = res.data.data.goods_type || [];
            this.manyGoodsLevelOptions = res.data.data.goods_level || [];
          }
        })
        .finally(() => {
          this.manyGoodsLoading = false;
        });
    },

    // 赏品库 - 选择类型联动等级
    handleManyGoodsTypeChange(type) {
      if (!type) {
        this.manyGoodsLevelOptions = [];
        this.manyGoodsSearch.level_id = "";
        return;
      }
      const target = this.manyGoodsTypeOptions.find((i) => i.type === type);
      this.manyGoodsLevelOptions = target ? target.goods_level : [];
      this.manyGoodsSearch.level_id = "";
    },

    // 赏品库 - 选中商品回填
    selectManyGoods(item) {
      this.manyForm.goods_id = item.id + ""; // 商品ID
      this.manyForm.goods_image = item.image; // 商品图片
      this.manyForm.goods_type = item.goods_type + ""; // 商品类型 1/2
      this.manyForm.level_id = item.level_id + ""; // 等级ID
      this.manyForm.price = item.price; // 价格自动回填
      this.manyForm.recovery_price = item.price; // 兑换价默认=价格
    },

    // 赏品库 - 重置搜索
    resetManyGoodsSearch() {
      this.manyGoodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 1,
      };
      this.manyGoodsTypeOptions = [];
      this.manyGoodsLevelOptions = [];
    },

    // 赏品库 - 分页
    handleManyGoodsSizeChange(val) {
      this.manyGoodsSearch.page_size = val;
      this.getManyGoodsList();
    },
    handleManyGoodsCurrentChange(val) {
      this.manyGoodsSearch.page = val;
      this.getManyGoodsList();
    },

    // 打开编辑
    openEditManyPrize(row) {
      this.manyForm = {
        prize_id: row.id + "",
        goods_id: row.goods_id + "",
        goods_image: row.goods_image || "",
        goods_type: row.goods_type + "",
        level_id: row.level_id + "",
        price: row.price + "",
        recovery_price: row.recovery_price + "",
        probability: row.probability + "",
      };
      this.manyEditDialogVisible = true;
    },

    // 提交添加 N 次赏
    async submitAddManyPrize() {
      // 提交前校验
      if (!this.manyForm.goods_id) return this.$message.warning("请选择赏品");
      if (!this.manyForm.price) return this.$message.warning("请输入价格");
      if (!this.manyForm.recovery_price)
        return this.$message.warning("请输入兑换价格");
      if (this.manyForm.probability === "")
        return this.$message.warning("请输入概率");

      this.manyLoading = true;
      try {
        // 严格按照你要求的参数传递
        const data = {
          box_id: this.currentManyBoxId, // 当前盲盒ID
          goods_id: this.manyForm.goods_id, // 商品ID
          goods_type: this.manyForm.goods_type, // 商品类型
          level_id: this.manyForm.level_id, // 等级ID
          price: this.manyForm.price, // 价格
          recovery_price: this.manyForm.recovery_price, // 兑换价格
          probability: this.manyForm.probability, // 概率
        };
        console.log(data);
        const res = await api.blindBox.addBlindManyPrize(data);

        if (res.data.code == 1000) {
          this.$message.success("添加成功");
          this.manyAddDialogVisible = false;
          this.getManyPrizeList(); // 刷新列表
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.manyLoading = false;
      }
    },

    // 提交编辑 N 次赏
    async submitEditManyPrize() {
      this.manyLoading = true;
      try {
        const res = await api.blindBox.editBlindManyPrize({
          prize_id: this.manyForm.prize_id,
          box_id: this.currentManyBoxId,
          goods_id: this.manyForm.goods_id,
          goods_type: this.manyForm.goods_type,
          level_id: this.manyForm.level_id,
          price: this.manyForm.price,
          recovery_price: this.manyForm.recovery_price,
          probability: this.manyForm.probability,
        });
        if (res.data.code == 1000) {
          this.manyEditDialogVisible = false;
          this.getManyPrizeList();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.manyLoading = false;
      }
    },

    // 删除
    async handleDelManyPrize(prize_id) {
      this.$confirm("确定删除该N次赏记录？", "提示", { type: "warning" }).then(
        async () => {
          this.manyLoading = true;
          try {
            const res = await api.blindBox.delBlindManyPrize({ prize_id });
            if (res.data.code == 1000) {
              this.getManyPrizeList();
            }
          } catch (e) {
          } finally {
            this.manyLoading = false;
          }
        }
      );
    },
    // ====================== PC 方法 ======================
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcProbList = this.levelList.map((item) => ({
        level_id: item.level_id,
        level_name: item.name,
        probability: 0,
      }));
      this.pcDialogVisible = true;
    },
    formatTwoDecimal(row, field) {
      let val = parseFloat(row[field] || 0);
      row[field] = val.toFixed(6);
    },
    async handlePcEdit(id) {
      this.pcDialogType = "edit";
      this.pcResetForm();
      this.loading = true;
      try {
        const res = await api.blindBox.detail({ params: { box_id: id } });
        if (res.data.code == 1000) {
          const d = res.data.data;
          this.pcForm = {
            box_id: d.id,
            name: d.name,
            cate_id: d.cate_id,
            image: d.image,
            price: d.price + "",
            sort: d.sort + "",
            cycle_num: d.cycle_num + "",
            custom_user_id: d.custom_user_id || "",
            custom_start: d.custom_start || "",
            custom_end: d.custom_end || "",
            blind_probability: JSON.stringify(d.blind_probability || []),
            flow_amount: d.flow_amount + "", // 新增
            goods_id: d.goods_id + "", // 新增
          };
          this.pcProbList = (d.blind_probability || []).map((item) => ({
            level_id: item.level_id,
            level_name: item.level_name,
            probability: parseFloat(item.probability),
          }));
          this.pcDialogVisible = true;
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    pcHandleProbChange() {
      this.pcForm.blind_probability = JSON.stringify(this.pcProbList);
    },
    pcSubmitForm() {
      const total = this.pcProbList.reduce(
        (sum, item) => sum + Number(item.probability || 0),
        0
      );
      if (total.toFixed(4) != 100.0) {
        this.$message.error(`概率必须=100%，当前：${total.toFixed(4)}%`);
        return;
      }
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn =
          this.pcDialogType == "add" ? api.blindBox.add : api.blindBox.edit;
        apiFn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => (this.loading = false));
      });
    },
    pcResetForm() {
      this.pcForm = {
        box_id: "",
        name: "",
        cate_id: "",
        image: "",
        sort: "",
        cycle_num: "",
        price: "",
        custom_user_id: "",
        custom_start: "",
        custom_end: "",
        blind_probability: "[]",
        flow_amount: "", // 新增
        goods_id: "", // 新增
      };
      this.pcProbList = [];
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },

    // PC 图片
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageUrl = "";
      this.pcGetImageList();
    },
    pcGetImageList() {
      this.pcImageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.pcImageList = res.data.data.data || [];
            this.pcImageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.pcImageLoading = false));
    },
    pcSelectImage(img) {
      this.pcSelectedImageUrl = img.url;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageUrl) {
        this.$message.warning("请选择图片");
        return;
      }
      this.pcForm.image = this.pcSelectedImageUrl;
      this.pcImageDialogVisible = false;
    },
    pcResetImageSearch() {
      this.pcImageSearch = { page: 1, page_size: 10, type: "" };
      this.pcGetImageList();
    },
    pcHandleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.pcGetImageList();
    },
    pcHandleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.pcGetImageList();
    },

    // ====================== 移动端 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    async openMobileEdit(id) {
      this.loading = true;
      try {
        const res = await api.blindBox.detail({ params: { box_id: id } });
        if (res.data.code == 1000) {
          const d = res.data.data;
          this.mobileEditForm = {
            box_id: d.id,
            name: d.name,
            cate_id: d.cate_id,
            image: d.image,
            price: d.price + "",
            cycle_num: d.cycle_num + "",
            sort: d.sort + "",
            custom_user_id: d.custom_user_id || "",
            custom_start: d.custom_start || "",
            custom_end: d.custom_end || "",
            blind_probability: JSON.stringify(d.blind_probability || []),
            flow_amount: d.flow_amount + "", // 新增
            goods_id: d.goods_id + "", // 新增
          };
          this.mobileProbList = (d.blind_probability || []).map((item) => ({
            level_id: item.level_id,
            level_name: item.level_name,
            probability: parseFloat(item.probability),
          }));
          this.mobileEditVisible = true;
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleMobileProbChange() {
      this.mobileEditForm.blind_probability = JSON.stringify(
        this.mobileProbList
      );
    },
    async submitMobileEdit() {
      const total = this.mobileProbList.reduce(
        (sum, item) => sum + Number(item.probability || 0),
        0
      );
      if (total.toFixed(4) != 100.0) {
        this.$message.error(`概率必须=100%，当前：${total.toFixed(4)}%`);
        return;
      }
      this.loading = true;
      try {
        const res = await api.blindBox.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    // 移动端图片
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.mobileGetImageList();
    },
    mobileGetImageList() {
      this.mobileImageLoading = true;
      api.images
        .index({ params: this.mobileImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.mobileImageList = res.data.data.data || [];
            this.mobileImageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.mobileImageLoading = false));
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl) {
        this.$message.warning("请选择图片");
        return;
      }
      this.mobileEditForm.image = this.mobileSelectedImageUrl;
      this.mobileImageDialogVisible = false;
    },
    mobileResetImageSearch() {
      this.mobileImageSearch = { page: 1, page_size: 10, type: "" };
      this.mobileGetImageList();
    },
    mobileHandleImageSizeChange(val) {
      this.mobileImageSearch.page_size = val;
      this.mobileGetImageList();
    },
    mobileHandleImageCurrentChange(val) {
      this.mobileImageSearch.page = val;
      this.mobileGetImageList();
    },

    // ====================== 公共 ======================
    loadGoodsTypeOptions() {
      api.goods.index({ params: { page: 1, page_size: 10 } }).then((res) => {
        if (res.data.code == 1000) {
          this.goodsTypeSelectOptions = res.data.data.goods_type || [];
        }
      });
    },
    async handleDelBoxPrize(row) {
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            this.prizeLoading = true;
            const res = await api.blindBox.delBoxPrize({ prize_id: row.id });
            if (res.data.code == 1000) this.getBoxPrizeList();
          } catch (e) {
          } finally {
            this.prizeLoading = false;
          }
        })
        .catch(() => this.$message.info("已取消"));
    },
    async handleStatusChange(row) {
      try {
        this.loading = true;
        const res = await api.blindBox.status({
          box_id: row.id,
          status: row.status,
        });
        if (res.data.code != 1000) row.status = row.status == 1 ? 0 : 1;
      } catch (e) {
        row.status = row.status == 1 ? 0 : 1;
      } finally {
        this.loading = false;
      }
    },
    async handleRowClick(row) {
      this.detailLoading = true;
      this.detailRow = null;
      this.detailDialogVisible = true;
      try {
        const res = await api.blindBox.detail({ params: { box_id: row.id } });
        if (res.data.code == 1000) {
          const data = res.data.data;
          data.remainText = row.remainText;
          this.detailRow = data;
        }
      } catch (err) {
      } finally {
        this.detailLoading = false;
      }
    },
    getList() {
      this.loading = true;
      api.blindBox
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.cateList = res.data.data.cate;
            this.levelList = res.data.data.level;
            this.pageTotal = res.data.data.total;
            this.updateRemainText();
          }
        })
        .finally(() => (this.loading = false));
    },
    updateRemainText() {
      const now = Date.now();
      this.tableData.forEach((row) => {
        if (!row.custom_end) {
          row.remainText = "—";
          return;
        }
        const end = new Date(row.custom_end).getTime();
        const diff = end - now;
        if (diff <= 0) {
          row.remainText = "已结束";
          return;
        }
        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);
        row.remainText = `${d}天 ${h}时 ${m}分 ${s}秒`;
      });
    },
    handlePrizeLevelChange(row) {
      const level = this.levelList.find((i) => i.level_id === row.level_id);
      if (level) row.level_name = level.name;
    },
    startRealTimeRefresh() {
      this.timer = setInterval(() => this.updateRemainText(), 1000);
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "", cate_id: "" };
      this.getList();
    },
    getImageTypeName(type) {
      const item = this.image_type.find((t) => t.type == type);
      return item ? item.desc : "未知";
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((item) => item.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },
    openPrizeDialog(row) {
      if (this.currentBoxId != row.id) {
        this.tempPrizeList = [];
        this.addedGoodsIds = [];
        this.selectedGoodsIds = [];
      }
      this.currentBoxId = row.id;
      this.prizeDialogVisible = true;
      this.goodsList.forEach((item) => (item._checked = false));
      this.loadPrizeTypeOptions();
      this.resetPrizeSearch();
    },
    loadPrizeTypeOptions() {
      api.goods.index({ params: this.goodsSearch }).then((res) => {
        if (res.data.code == 1000) {
          this.prizeTypeOptions = res.data.data.goods_level || [];
          this.goodsTypeOptions = res.data.data.goods_level || [];
        }
      });
    },
    handlePrizeTypeChange(type) {
      if (!type) {
        this.prizeLevelOptions = [];
        this.prizeSearch.level_id = "";
        return;
      }
      const target = this.prizeTypeOptions.find((i) => i.type === type);
      this.prizeLevelOptions = target ? target.goods_level : [];
      this.prizeSearch.level_id = "";
    },
    getBoxPrizeList() {
      this.prizeLoading = true;
      let params = {
        box_id: this.currentBoxId,
        page: this.prizeSearch.page,
        page_size: this.prizeSearch.page_size,
        type: this.prizeSearch.type || "",
        level_id: this.prizeSearch.level_id || "",
      };
      api.blindBox
        .boxList({ params })
        .then((res) => {
          if (res.data.code == 1000) {
            this.prizeList = res.data.data.data || [];
            this.prizeTotal = res.data.data.total || 0;
            this.sum_numsum_proObj = res.data.data;
          }
        })
        .finally(() => (this.prizeLoading = false));
    },
    resetPrizeSearch() {
      this.prizeSearch = { page: 1, page_size: 10, type: "", level_id: "" };
      this.prizeLevelOptions = [];
      this.getBoxPrizeList();
    },
    handlePrizeSizeChange(val) {
      this.prizeSearch.page_size = val;
      this.getBoxPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeSearch.page = val;
      this.getBoxPrizeList();
    },
    openAddPrizeDialog() {
      this.addPrizeDialogVisible = true;
      this.getGoodsList(() => {
        // 自动勾选 + 同步选中ID
        this.selectedGoodsIds = [];
        this.goodsList.forEach((g) => {
          // 判断是否已经在待提交列表
          const isAdded = this.tempPrizeList.some(
            (item) => item.goods_id == g.id
          );
          g._checked = isAdded;

          // 同步到选中数组
          if (isAdded) {
            this.selectedGoodsIds.push(g.id);
          }
        });
      });
    },
    handleGoodsTypeChange(type) {
      if (!type) {
        this.goodsLevelOptions = [];
        this.goodsSearch.level_id = "";
        return;
      }
      const target = this.goodsTypeOptions.find((i) => i.type === type);
      this.goodsLevelOptions = target ? target.goods_level : [];
      this.goodsSearch.level_id = "";
    },
    getGoodsList(callback) {
      this.goodsLoading = true;
      api.goods
        .index({ params: this.goodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.goodsList = res.data.data.data || [];
            this.goodsList.forEach((item) => {
              this.$set(item, "_checked", this.addedGoodsIds.includes(item.id));
            });
            this.goodsTotal = res.data.data.total || 0;
            if (callback) callback();
          }
        })
        .finally(() => (this.goodsLoading = false));
    },
    handleSelectGoods(row) {
      row._checked = !row._checked;
      this.$set(row, "_checked", row._checked);
      if (row._checked) {
        if (!this.selectedGoodsIds.includes(row.id))
          this.selectedGoodsIds.push(row.id);
      } else {
        this.selectedGoodsIds = this.selectedGoodsIds.filter(
          (id) => id !== row.id
        );
      }
    },
    addSelectedToPrizeList() {
      if (this.selectedGoodsIds.length === 0) {
        return this.$message.warning("请选择商品");
      }

      let selectedGoods = this.goodsList.filter((g) => g._checked);

      selectedGoods.forEach((g) => {
        // 这里统一使用 goods_type
        const isVirtual = g.goods_type == 2;
        const isExist = this.tempPrizeList.some((i) => i.goods_id == g.id);

        // 真实赏品，已存在 → 跳过
        if (!isVirtual && isExist) return;

        this.tempPrizeList.push({
          goods_id: g.id,
          goods_title: g.title,
          goods_image: g.image,
          level_id: g.level_id,
          level_name: g.level_name,
          goods_type: g.goods_type, // 统一字段
          price: g.price,
          recovery_price: g.price,
          origin_num: 0,
          probability: 0,
        });
      });

      this.addPrizeDialogVisible = false;
      this.$message.success("添加成功");
    },
    delTempPrize(row) {
      this.tempPrizeList = this.tempPrizeList.filter(
        (i) => i.goods_id != row.goods_id
      );
      this.addedGoodsIds = this.addedGoodsIds.filter(
        (id) => id !== row.goods_id
      );
      const goodsItem = this.goodsList.find((g) => g.id === row.goods_id);
      if (goodsItem) goodsItem._checked = false;
      this.selectedGoodsIds = this.selectedGoodsIds.filter(
        (id) => id !== row.goods_id
      );
    },
    async submitAllPrize() {
      if (this.tempPrizeList.length == 0) {
        this.$message.warning("请添加赏品");
        return;
      }
      let prize_info = this.tempPrizeList.map((i) => ({
        goods_id: i.goods_id,
        probability: i.probability,
        origin_num: i.origin_num,
        level_id: i.level_id,
        price: parseFloat(i.price),
        recovery_price: parseFloat(i.recovery_price),
        goods_type: i.goods_type,
      }));
      this.submitLoading = true;
      try {
        const res = await api.blindBox.addBoxPrize({
          box_id: this.currentBoxId,
          prize_info: JSON.stringify(prize_info),
        });
        if (res.data.code == 1000) {
          this.getBoxPrizeList();
          this.tempPrizeList = [];
          this.addedGoodsIds = [];
          this.selectedGoodsIds = [];
          this.goodsList.forEach((item) => (item._checked = false));
        }
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    resetGoodsSearch() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
      };
      this.selectedGoodsIds = [];
      this.goodsLevelOptions = [];
      this.goodsList.forEach((item) => this.$set(item, "_checked", false));
      this.getGoodsList();
    },
    handleGoodsSizeChange(val) {
      this.goodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsSearch.page = val;
      this.getGoodsList();
    },
    openEditPrizeDialog(row) {
      this.editPrizeForm = {
        prize_id: row.id + "",
        origin_num: row.origin_num + "",
        probability: row.probability + "",
        goods_id: row.goods_id + "",
        goods_image: row.goods_image,
        goods_title: row.goods_title,
        level_id: row.level_id + "",
        price: row.price + "",
        recovery_price: row.recovery_price + "",
        goods_type: row.goods_type + "",
      };
      this.editPrizeDialogVisible = true;
    },
    async submitEditPrize() {
      this.editPrizeLoading = true;
      try {
        const res = await api.blindBox.editBoxPrize(this.editPrizeForm);
        if (res.data.code == 1000) {
          this.editPrizeDialogVisible = false;
          this.getBoxPrizeList();
        }
      } catch (e) {
      } finally {
        this.editPrizeLoading = false;
      }
    },


    // ====================== 新增：盲盒抽奖记录 ======================
openDrawRecord(row) {
  this.currentDrawBoxId = row.id
  this.drawRecordSearch.box_id = row.id
  this.drawRecordSearch.page = 1
  this.drawRecordDialogVisible = true
  this.getDrawRecordList()
},
async getDrawRecordList() {
  this.drawRecordLoading = true
  try {
    const res = await api.blindCate.boxDrawRecord({
      params: this.drawRecordSearch
    })
    if (res.data.code == 1000) {
      this.drawRecordList = res.data.data.data || []
      this.drawRecordTotal = res.data.data.total || 0
    }
  } catch (e) {
    console.error('获取抽奖记录失败', e)
  } finally {
    this.drawRecordLoading = false
  }
},
handleDrawRecordSizeChange(val) {
  this.drawRecordSearch.page_size = val
  this.getDrawRecordList()
},
handleDrawRecordCurrentChange(val) {
  this.drawRecordSearch.page = val
  this.getDrawRecordList()
},
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.detail-content {
  padding: 10px 0;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/blind/index.vue